import { render, staticRenderFns } from "./PBoundaryLine.vue?vue&type=template&id=1d2002a0&scoped=true&"
import script from "./PBoundaryLine.vue?vue&type=script&lang=ts&"
export * from "./PBoundaryLine.vue?vue&type=script&lang=ts&"
import style0 from "./PBoundaryLine.vue?vue&type=style&index=0&id=1d2002a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2002a0",
  null
  
)

export default component.exports